import { useCallback } from 'react'

import copy from 'copy-to-clipboard'

const useCopyToClipboard = (value) => {
  return useCallback(() => copy(value), [value])
}

export { useCopyToClipboard }
